import Reflux from 'reflux';
import RetIvaActions from '../RetIvaActions';

var RetIvaFormStore = Reflux.createStore({
    init: function() {
        this.listenToMany(RetIvaActions);
    },

    inputChange: function(e, factura, line, blur) {
        let value = e.target.value,
            name = e !== null ? e.target.name : 'fechaFact';
   
        if (name === 'baseImponible' || name === 'sinCredito'){
            value = value.replace(',','.');
            value = parseFloat(value);
        }
        
        factura[name] = value;

        /** 
        if (factura.tipo_pago === 'electronico' && factura.baseImponible > 1999999) {
            factura.porcentaje_iva = 7;
        } else if (factura.tipo_pago === 'electronico' && factura.baseImponible < 2000000) {
            factura.porcentaje_iva = 9;
        } else {
            factura.porcentaje_iva = 12;
        }
        */
        this.trigger(factura, line, blur);
    }
});

export default RetIvaFormStore;


/** WEBPACK FOOTER **
 ** ./app-react/reflux/stores/RetIvaFormStore.js
 **/